import React from "react";
import { AlertTriangle, RefreshCcw } from "lucide-react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { failed: false };
  }

  static getDerivedStateFromError() {
    return { failed: true };
  }

  componentDidCatch(error, info) {
    if (process.env.NODE_ENV !== "production") {
      console.error("MonitorFlux view failed", error, info);
    }
  }

  render() {
    if (!this.state.failed) return this.props.children;
    return (
      <main role="alert" className="flex min-h-[70vh] flex-col items-center justify-center gap-4 px-5 py-12 text-center">
        <div className="flex h-14 w-14 items-center justify-center rounded-2xl bg-amber-50 text-amber-700">
          <AlertTriangle size={27} aria-hidden="true" />
        </div>
        <h1 className="max-w-md text-2xl font-semibold text-slate-900">Something interrupted this page</h1>
        <p className="max-w-md text-sm leading-6 text-slate-600">
          Your monitoring data is safe. Reload the page to try again. If the issue persists, contact Omaxtech Technologies support.
        </p>
        <button type="button" onClick={() => window.location.reload()}
          className="inline-flex min-h-11 items-center gap-2 rounded-xl bg-blue-700 px-5 py-2.5 font-semibold text-white hover:bg-blue-800 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-blue-700">
          <RefreshCcw size={17} aria-hidden="true" /> Reload page
        </button>
      </main>
    );
  }
}
